import React, { useState } from "react";
import { QRFlowLeftNavBar } from "../ReusableComp/NavBarLeft";
import NavigationBar from "../ReusableComp/NavigationBar";
import { Col, Container, Modal, ModalFooter, Row, Stack, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
import CryptoJS from 'crypto-js';
import {
  getAllWhoddClassification,
  getSubjectInformation,
  getReviewSubjDtls,
  getPmsNotifications
} from "../../Redux/actions/actions";
import {
  base_url,
  QUALITY_REVIEWER,
  SUBJECT_REVIEW_STATUS_SENT_BACK_FOR_REVIEW,
  SUBJECT_REVIEW_STATUS_REVIEWED,
  SUBJECT_REVIEW_STATUS_IN_PROGRESS,
  SUBJECT_REVIEW_STATUS_WAITING_FOR_REVIEW,
  MEDDRA_ALLERGIES,
  MEDDRA_CONCURRENT_ILLNESS,
  MEDDRA_MEDICAL_HISTORY,
  WHODD_ANY_MEDICATION_USED_IN_LAST_3WEEKS,
  WHODD_CONCOMITANT_MEDICATION,
  CRYPTO_SECRET_KEY
} from "../../utilities";
import axios from "axios";
import PopUpModal, { PopUpAlert } from "../ReusableComp/PopUpModal";
import Loader from '../ReusableComp/Loader';
import SubjectReviewDetails from "./SubjectReviewDetails";
 
import { ThreeDots } from "react-loader-spinner";
import { MeddraArray, MeddraForm, WhoDDForm, WhoddSearchBlock, handleWhoDDClassification } from "./ReviewList";
import PasswordModal from "./PasswordModal";

const QrSubjectReview = () => {
  const dispatch = useDispatch();
  const revSubjDtls = useSelector((state) => (state.revSubjDtls));
  const aeSubject = useSelector((state) => state.getAeOfSubj);
  const [loading, setLoading] = useState(false);
  const[reviewFlag,setReviewFlag]=useState(false)
  const [modalAlert, setModalAlert] = useState(false)
  const [modalWhoddCloseAlert, setModalWhoddCloseAlert] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentIndexWhoDD, setCurrentIndexWhoDD] = useState(0);
  const [whoDDCodeArray, setWhoDDCodeArray] = useState([])
  const [meddraCodeArray, setMeddraCodeArray] = useState([])
  const [masterArray, setMasterArray] = useState([])
  const [masterObjectArray, setMasterObjectArray] = useState([])
  const [loadFlag1, setLoadFlag1] = useState(false)
  const [suggestionsWhodd, setSuggestionsWhodd] = useState([])
  const [dotsFlag1, setDotsFlag1] = useState(false)
  const [listFlag1, setListFlag1] = useState(false)
  const [subjectID, setSubjectID] = useState('')
  const [noRecordsFlag1 ,setNoRecordsFlag1] = useState(false)
  const [medicationId, setMedicationId] = useState()
  const [medicationDetails, setMedicationDetails] = useState([
    {
      "searchTerm": "",
      "whoDD_type": "",
      "medication_id":"",
      "current_idx": 0,
      "whoDDEncode": false,
      "whoddArray": [],
      "concmtntWhoDDArray": [],
    },
  ]);
 

  const qrSubjectList = useSelector((state) => state.qrSubjectReviewList);
  const subjectCounts = useSelector((state) => state.qrSubjectsRelatedcounts);
  const qrSubjectInfoList = useSelector((state) => state.qrSubjectInfoList);

  const [currentPage, setCurrentPage] = useState(1);
  const [filteredData, setFilteredData] = useState(null);
  const [searchText, setSearchText] = useState("");
  let [loading_flag, Setloading_flag] = useState(false);
  const [asc,setAsC]=useState(false);
  const [desc,setDesc]=useState(false);
  const getEventFlag = useSelector((state) => state.getEventFlag);  
  const [selectedOption, setSelectedOption] = useState(getEventFlag?.option); 
  const [meddraDetails, setMeddraDetails] = useState([
    {
     
      "searchTerm": "",
      "current_idx": 0,
      "meddra_type": null,
      "checkedMeddra":"",
      "medDRAEncode": false,
      "meddraAllergies": [],
      "meddraMhArray": [],
      "meddraIllArray": [],

    },
  ]);

  const [open, setOpen] = React.useState(false);
  const [openTwo, setOpenTwo] = React.useState(false);
  const [openThree, setOpenThree] = React.useState(false);
  const [listFlag, setListFlag] = useState(false)
  const [dotsFlag, setDotsFlag] = useState(false)
  const [open1, setOpen1] = useState(false)
    const [subjData, setSubjData] = useState([]);
  const [studyDropdwn, setStudyDropdwn] = useState(false);
  const [reviewedDtls, setReviewedDtls] = useState(false);
  const [alertMessage, setAlrtMessage] = useState('')
  const [btnId, setBtnId] = useState('')
  const [value, setValue] = useState("");
  const [value1, setValue1] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const[noRecordsFlag, setNoRecordsFlag] = useState(false)
  const [encodeMedBtn, setEncodeMedBtn] = useState(true)
const [encodeMeddrabtn, setEncodeMeddrabtn] = useState(true);

const[saveBtnWhodd, setSaveBtnWhodd]=useState(true)

  const [array, setArray] = useState([])

  useEffect(() => {
    if(reviewFlag){
      if(localStorage.access_token !== "undefined" && revSubjDtls 
    && window.location.pathname==='/qrsubjectreview' && currentPage===2 && <i className="fa-solid fa-check text-success"/>){
      setLoading(false)
    }}
    else {
      if(localStorage.access_token !== "undefined"  
    && window.location.pathname==='/qrsubjectreview' && currentPage===2 && <i className="fa-solid fa-check text-success"/>){
      setLoading(false)
    }}

    Setloading_flag(true);
    if(selectedOption === 'subject_with_pending'){
      setFilteredData(qrSubjectList.filter(i => i.review_status === 0 || i.review_status ===1))
    }else if (selectedOption === 'all_events' || selectedOption === "total_reviews") {
      setSelectedOption("all_events")
      setFilteredData(qrSubjectList)
    }else {
      setSelectedOption("all_events")
      setFilteredData(qrSubjectList)
    }
    setTimeout(() => {
      Setloading_flag(false);
    }, 1000);


  }, [dispatch,reviewFlag,revSubjDtls,currentPage, localStorage.pi_id,localStorage.study_id,qrSubjectList !== null, medicationId]);

  const medraList = useSelector((state) => (state.medraList));

  const whoddList = useSelector((state) => (state.whoddList));

  useEffect(()=>{

    if(qrSubjectList){
      setFilteredData(qrSubjectList)
    }
  },[qrSubjectList])
 
 

  const dateOfReport = aeSubject?.date_of_report;
  const lastDayActiveFollowUp = aeSubject?.last_day_active_follow_up;
  const stepperData = [];
  const date = new Date(dateOfReport);
  while (date <= new Date(lastDayActiveFollowUp)) {
    stepperData.push({
      day: `Day${stepperData.length + 1}`,
      dateOfevent: date.toISOString().split("T")[0],
    });
    date.setDate(date.getDate() + 1);
  }
  function exportToExcel() {

    let excelArray = [];
    filteredData.forEach((i) => {

      switch (i.review_status) {
        case SUBJECT_REVIEW_STATUS_WAITING_FOR_REVIEW:
          i.review_status = "Waiting for review";
          break;
        case SUBJECT_REVIEW_STATUS_IN_PROGRESS:
          i.review_status = "In progress";
          break;
        case SUBJECT_REVIEW_STATUS_REVIEWED:
          i.review_status = "Reviewed";
          break;
        case SUBJECT_REVIEW_STATUS_SENT_BACK_FOR_REVIEW:
          i.review_status = "Sent back for review";
          break;
        default:
          break;
      }

      let xl_object = {
        "Principal Investigator": i.pi_name,
        "Sex": i.sex,
        "Site Name": i.site_name,
        "Subject ID": i.subject_code,
        "Status": i.review_status,
      };
      excelArray.push(xl_object);
    });
    // create the data that you want to write to the excel file
    const data = excelArray;

    // create a worksheet and add the data to it
    const worksheet = XLSX.utils.json_to_sheet(data);

    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const fileName = "Qr_review_subjects_list.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
  }
  

  const handleRadioChange = (selectedValue) => {
    setSelectedOption(selectedValue);
    if(selectedValue === 'subject_with_pending'){
      setFilteredData(qrSubjectList.filter(i => i.review_status === 0 || i.review_status ===1))
    }else if (selectedValue === 'all_events') {
      setFilteredData(qrSubjectList)
    }
  };

  const dashboardCards = [

    {
      count: subjectCounts?.reviewSubjectsCount,
      image: "./images/icons/pending approval.svg",
      desc: "Pending",
      bgcolor: "#EAEAEA",
      textColor: "#000000",
      id:"subject_with_pending"
    },
    {
      count: subjectCounts?.subjectsCount,
      image: "./images/icons/subjects_white.svg",
      desc: "Total Subjects",
      bgcolor: "#8DA2B5",
      textColor: "white",
      id:"all_events"
    },
  ];


  const handleStudyChange = () => {
    setFilteredData(null);
    setSearchText("");
  };

  const handleSearchData = (event) => {
    const searchText = event.target.value?.toLowerCase();
    setSearchText(searchText);
    const filteredData = qrSubjectList?.filter((item) => {
      const { subject_code ,site_name} = item;

      const formattedSubjectCode = subject_code?.toLowerCase();
      const formattedSiteName = site_name ? site_name.toLowerCase() : ""
      return (
        formattedSubjectCode.includes(searchText) ||
        formattedSiteName.includes(searchText)
      );
    });

    setFilteredData(filteredData);
  };



  
 


    

    const alreadyAttended = ()=>{
      setOpen1(false)
      window.location.reload()

    }

  const handleSubjectData = (data) => {
    setLoading(true)
    setSubjectID(data.subject_id)
    dispatch(getSubjectInformation(data.subject_id))
    if (medraList) {
      setCurrentPage(2);
    }
    const getStatus = filteredData?.find(item => item.subject_id === data.subject_id).status
    
    if(getStatus === SUBJECT_REVIEW_STATUS_SENT_BACK_FOR_REVIEW){
          setOpen1(true)
    }
    if (data.review_status === SUBJECT_REVIEW_STATUS_REVIEWED) {
      setReviewFlag(true)
      setReviewedDtls(true);

      dispatch(getReviewSubjDtls({
        "subject_id": data.subject_id
      }))


    }
    setSubjData(data)
    if(data.review_status !== SUBJECT_REVIEW_STATUS_REVIEWED){
    dispatch(getAllWhoddClassification())
    }
  
    if (data.review_status === 0) {
      axios
        .post(
          base_url + "quality-reviewer/update_subject_review_status_inprogress", { "subject_id": data.subject_id }
        )
        .then((res) => {
          setStudyDropdwn(true);
          setCurrentPage(2);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      setStudyDropdwn(true);
      setCurrentPage(2);
    }
  };

  const [medraSelected, setIsMedraSelected] = useState(false)

  
  const [reviewerComment, setReviewerComment] = useState('')
  const handleReviewerComments = (e) => {
    let val = e.target.value;
    let value = val.trim()
    setReviewerComment(value || '')
    if (value !== '') { (setIsMedraSelected(true)) } else { setIsMedraSelected(false) }
  };
  
  function sentBack() {
    setLoading(true)
    axios
      .post(base_url + "comments/add_subject_review_comment", {
        "subject_id": subjectID,
        "reviewer_id": localStorage.qr_id,
        "user_persona": QUALITY_REVIEWER,
        "comment": reviewerComment,
        "review_status": SUBJECT_REVIEW_STATUS_SENT_BACK_FOR_REVIEW,
        "created_by": localStorage.login_user_name
      })
      .then((res) => {
        setAlrtMessage("Successfully sent back for correction")
        setLoading(false)
        setPwdModalShow(false)
        setModalAlert(true)
      })
  }
 
function handleAlertTwo(){
  handleSaveMeddra()
  setOpenTwo(false)
}
function handleAlertThree(){
  handleSaveWhoDD()
  setOpenThree(false)
}

const [pwdModalShow, setPwdModalShow] =useState(false)

  function handleReviewActions() {
    if (btnId === 'cancel') {
      setOpen(false)
    } else if (btnId === "sendBack") {
      setOpen(false)
      setPwdModalShow(true) 
      } else if (btnId === 'closereview') {
        setOpen(false)
        setPwdModalShow(true)
    }
  }

  function handleClosePopup() {
    setModalWhoddCloseAlert(false)
    setOpen(false)
    setOpenTwo(false)
    setOpenThree(false)
    setOpen1(false)
    
  }
  function handleNoModalAlert() {
    setModalAlert(false)
  }
  
  function handlecloseReview() {
    // setLoading(true)
    const newConcatWhodd = masterObjectArray.map(i =>({medication_id: i?.medication_id, whodd_id:i.whodd_id}))//need concomitant medication {medication_id: VALUE, whodd_id: VALUE}
    const newpastWhodd = masterArray.map(i =>({medication_id: i?.medication_id, whodd_id:i.whodd_id}))
    // const concatenatedArray = newConcatWhodd.concat(newpastWhodd);
    let medraWhoDDObj = {
      "subject_id": subjectID,
      "reviewer_id": localStorage.qr_id,
      "created_by": localStorage.login_user_name,
      "user_persona": QUALITY_REVIEWER,
      "comment": reviewerComment,
      "meddraObjects": meddraCodeArray,
      "concomitantWhoddArray" : newConcatWhodd,
      "last3WeeksWhoddArray" : newpastWhodd,
    }

     
    axios
      .post(base_url + "medical-dictionaries/finish_subject_review", medraWhoDDObj)
      .then((res) => {
setLoading(false)
setPwdModalShow(false)
setAlrtMessage("Review Success")
setModalAlert(true)
      })
  }
  function handleReviewBtns(e) {
    
    let id = e.target.id;
    setBtnId(id)
    dispatch(getPmsNotifications({
      user_id: localStorage.login_user_id,
      user_persona: QUALITY_REVIEWER
    }))
    if (id === 'sendBack') {
      setAlrtMessage("Are you sure you want to send back for correction?")
      setOpen(true)
    } else if (id === 'closereview') {
      setAlrtMessage("Are you sure you want to close the review?")
      setOpen(true)
    }
    else {
      // dispatch(resetEventDetails())
      // dispatch(resetSubjectProfile())
      setCurrentPage(1)
      window.location.reload()
    }
  }

 
 




  const fetchSuggestionsWhodd = async (searchQuery) => {
    axios
    .post(base_url + "whodd/fetch_drug_names_based_on_search_term",{"search_term":searchQuery})
    .then((response) => {


      setSuggestionsWhodd(response.data.data.productNames)
      setDotsFlag1(false)
    if(response.data.data.length===0){
      setNoRecordsFlag1(true)
    }
    else{
      setNoRecordsFlag1(false)
    }
    })
  }



 



  const handleWhoDDClassification = (event, index) => {
   
    const inputValue = event.target.value;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      if (inputValue.length > 2) {
        setListFlag1(true)
        setDotsFlag1(true)
        fetchSuggestionsWhodd(inputValue);
      } else {
        setListFlag1(false)
        setDotsFlag1(false)
        setSuggestionsWhodd([]);
      }
    }, 300);
   
    medicationDetails.map((data) => {
      if (data.current_idx == index) {
        if (event.target.value == "") {
          data.whoDDEncode = true
          setSaveBtnWhodd(true)
          let fData = masterArray?.filter(i => i.medication_id!==medicationId && i.index !== index)
          setMasterArray(fData)
          let mobjData = masterObjectArray?.filter(i => i.medication_id!==medicationId && i.index !== index)
          setMasterObjectArray(mobjData)
          data.whoddArray = []
          data.searchTerm = ''
          setMedicationDetails(medicationDetails)
          setEncodeBtn(false)

        } else {
          data.whoDDEncode = false
          setValue1(event.target.value);
          data.searchTerm = event.target.value
          setMedicationDetails(medicationDetails)
          setEncodeBtn(true)
        }

      }
    })

  };
  
  
  let debounceTimer;
  const handleMeddraClassification1 = (event, index) => {
    setNoRecordsFlag(false);
    setListFlag(true)
    setDotsFlag(true)
    const inputValue = event.target.value;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      if (inputValue.length > 0) {
        fetchSuggestions(inputValue);
      } else {
        setSuggestions([]);
      }
    }, 300); 
    setMeddraCodeArray((prev) => prev.filter((data) => data.index !== index));

    meddraDetails.map(data => {
      if (data.current_idx == index) {
        if (event.target.value == "") {
          setListFlag(false)
          setDotsFlag(false)
          setNoRecordsFlag(false)
          data.meddraAllergies = []
          data.meddraMhArray = []
          data.meddraIllArray = []
          setValue("")
          data.searchTerm = ''
          setEncodeMeddrabtn(true)
          setEncodeMedBtn(false)
          data.medDRAEncode =true
          data.checkedMeddra=''
          
        } else {
          data.medDRAEncode =false
          setValue(event.target.value);
          data.searchTerm = event.target.value
          setEncodeMeddrabtn(true)
          setEncodeMedBtn(true)
        }
      }
    })
    setMeddraDetails(meddraDetails)
  };
 
  
  const fetchSuggestions = async (searchQuery) => {
    axios
    .post(base_url + "meddra-master/fetch_all_llt_names_based_on_search_term",{"llt_name":searchQuery})
    .then((response) => {
      setDotsFlag(false)
    setSuggestions(response.data.data)
    if(response.data.data.length===0){
      setNoRecordsFlag(true)
    }
  })
}

  const onSearch = (sTerm, index) => {
    setListFlag(false)
    setValue(sTerm);
    meddraDetails.map((data, index1) => {
      if (data.current_idx == index) {
        data.searchTerm = sTerm
        data.medDRAEncode = true
        setMeddraDetails(meddraDetails)
      }
    })
  };
  const [encodeBtn, setEncodeBtn] = useState(true)

  const onSearch1 = (searchTerm, index) => {
    
    let updatedData = [...masterObjectArray]
    updatedData?.map((ele,i)=>{
    if(ele.index==index){
      updatedData.splice(i,1)
    }
  })
  setMasterObjectArray(updatedData)
    setValue1(searchTerm);
    setListFlag1(false)
    setDotsFlag1(false)
    setEncodeBtn(false)
    medicationDetails.map((data, index1) => {
      // data.whoDDEncode = true;
      if (data.current_idx == index) {
        data.whoDDEncode = false
        data.whoddArray=[]
        data.searchTerm = searchTerm
        setMedicationDetails(medicationDetails)
      }
    })
 
    setSuggestionsWhodd([])
  };

  const handleDeleteFields = (index) => {
    setEncodeMeddrabtn(false)
    let updatedData = [...meddraDetails]
    let updatedMeddraCodeArray = [...meddraCodeArray]

    updatedMeddraCodeArray?.map((elemObj, i) => {
      if (elemObj.index == index) {
        updatedMeddraCodeArray.splice(i, 1)
      }
    })
    setMeddraCodeArray(updatedMeddraCodeArray)

    updatedData?.map((elemObj, i) => {
      if (elemObj.current_idx == index) {
        updatedData.splice(i, 1)
      }
    })
    setMeddraDetails(updatedData)
  }

  const handleDeleteFieldsWhoDD = (index) => {
    let updatedData = [...medicationDetails]
    updatedData?.map((elemObj, i) => {
      if (elemObj.current_idx == index) {
        updatedData.splice(i, 1)
      }
    })
    whoDDCodeArray?.map((item, i) =>{
      if(item.index === index){
        whoDDCodeArray.splice(i,1)
      }
    })
    setMedicationDetails(updatedData)
  }



  const onEncode1 = (searchTerm, object) => {
     
    setSaveBtnWhodd(false)
 

    setValue1(searchTerm);
    setListFlag1(false)
    setDotsFlag1(true)
    setLoadFlag1(true)
    axios
      .post(
        base_url + "whodd/fetch_complete_drug_details", {
        "drug_name": searchTerm
      }
      )
      .then((res) => {
        let whoddArray = res.data.data

        setLoadFlag1(false)
        setDotsFlag1(false)
          setArray(whoddArray)
          medicationDetails.map((data, index) => {
            
            if (data.current_idx === object.current_idx) {
              data.whoDDEncode = true
              medicationDetails[index].whoddArray = whoddArray;
              setMedicationDetails(medicationDetails)
              // ====================
              if (whoddArray?.length === 1) {
                setSaveBtnWhodd(false)
                if (typeId === WHODD_CONCOMITANT_MEDICATION) {
                  let newObj = {
                    index: object.current_idx,
                    medication_id: medicationId,
                    whodd: whoddArray[0].whodd_id,
                  }
                  const newArray = [...masterObjectArray];
                  const newIndex = index
                  if (newIndex < newArray.length) {
                    newArray[newIndex] = newObj;
                  } else {
                    newArray.push(newObj);
                  }
                  setMasterObjectArray(newArray);
                }

//-----------------------------------------------------------------
                else if (typeId === WHODD_ANY_MEDICATION_USED_IN_LAST_3WEEKS) {
                  
                  let newObj = {
                    index: object.current_idx,
                    medication_id: medicationId,
                    whodd: whoddArray[0].whodd_id,
                  }
                  const newArray = [...masterArray];
                  const newIndex = index 
                  if (newIndex < newArray.length) {
                    newArray[newIndex] = newObj;
                  } else {
                    newArray.push(newObj);
                  }
                  setMasterArray(newArray);

                
                }

              } else {
                setSaveBtnWhodd(true)
                if (typeId === WHODD_CONCOMITANT_MEDICATION) {
                  setMasterObjectArray((prev) => {
                    const updatedArray = prev.map((item) => {
                      if (item.medication_id === medicationId) {
                        return {
                          index: object.current_idx,
                          medication_id: medicationId,
                          whodd_id: null,
                        };
                      }
                      return item;
                    });

                    if (!updatedArray.some((item) => item.medication_id === medicationId)) {
                      updatedArray.push({
                        index: object.current_idx,
                        medication_id: medicationId,
                        whodd_id: null,
                      });
                    }

                    return updatedArray;
                  });

                } else if (typeId === WHODD_ANY_MEDICATION_USED_IN_LAST_3WEEKS) {
                  setMasterArray((prev) => {
                    const updatedArray = prev.map((item) => {
                      if (item.medication_id === medicationId) {
                        return {
                          index: object.current_idx,
                          medication_id: medicationId,
                          whodd_id: null,
                        };
                      }
                      return item;
                    });

                    if (!updatedArray.some((item) => item.medication_id === medicationId)) {
                      updatedArray.push({
                        index: object.current_idx,
                        medication_id: medicationId,
                        whodd_id: null,
                      });
                    }

                    return updatedArray;
                  })

                }

              }
            }
          })
      })
  }
  const onEncode2 = (searchTerm, object) => {
    setListFlag(false)
    setValue(searchTerm);
    axios
    .post(
      base_url + "meddra-master/fetch_llt_occurences", {
        "llt_name": searchTerm
    }
    )
    .then((res) => {
    const meddraArray = res.data.data;

    setArray(meddraArray)
    meddraDetails.map((data, index) => {
      if (data.current_idx == object.current_idx) {
        data.medDRAEncode = true
        data.checkedMeddra = ""
        if (meddraDetails[index].meddra_type === MEDDRA_ALLERGIES) {
          meddraDetails[index].meddraAllergies = meddraArray;
        
          if (meddraArray.length === 1) {
            setEncodeMeddrabtn(false)
            setMeddraCodeArray((prev) => ([...prev,
            {
              "meddra_llt_master_id": meddraArray[0]?.meddra_llt_master_id,
               "meddra_type": typeId,
              "index": object.current_idx,
              "meddra_mdhier_master_id":meddraArray[0]?.meddra_mdhier_master_id

            }
            ]))
          }else{
            setMeddraCodeArray((prev) => ([...prev,
              {
                "meddra_llt_master_id": null,
                 "meddra_type": typeId,
                "index": object.current_idx,
                "meddra_mdhier_master_id":null,
              }
              ]))
          }
        }
        if (meddraDetails[index].meddra_type === MEDDRA_MEDICAL_HISTORY) {
          meddraDetails[index].meddraMhArray = meddraArray;
       
          if (meddraArray.length === 1) {
            setEncodeMeddrabtn(false)
            setMeddraCodeArray((prev) => ([...prev,
            {
              "meddra_llt_master_id": meddraArray[0]?.meddra_llt_master_id,
               "meddra_type": typeId,
              "index": object.current_idx,
              "meddra_mdhier_master_id":meddraArray[0]?.meddra_mdhier_master_id
            }
            ]))
          }else{
            setMeddraCodeArray((prev) => ([...prev,
              {
                "meddra_llt_master_id": null,
                 "meddra_type": typeId,
                "index": object.current_idx,
                "meddra_mdhier_master_id":null
              }
              ]))
          }
        }
        if (meddraDetails[index].meddra_type === MEDDRA_CONCURRENT_ILLNESS) {
          meddraDetails[index].meddraIllArray = meddraArray;
          if (meddraArray.length === 1) {
            setEncodeMeddrabtn(false)
            setMeddraCodeArray((prev) => ([...prev,
            {
              "meddra_llt_master_id": meddraArray[0]?.meddra_llt_master_id,
               "meddra_type": typeId,
              "index": object.current_idx,
              "meddra_mdhier_master_id":meddraArray[0]?.meddra_mdhier_master_id
            }
            ]))
          }else{
            setMeddraCodeArray((prev) => ([...prev,
              {
                "meddra_llt_master_id": null,
                 "meddra_type": typeId,
                "index": object.current_idx,
                "meddra_mdhier_master_id":null,
              }
              ]))
          }
        }
      
      }
    })

  })
  .catch((error) => {
    console.log(error);
  });


  }

  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);

  const [currentSelectedIndex, setCurrentSelectedIndex] = useState();

  
  const handleCheckboxChange = (event, checkboxId, index) => {
    setSaveBtnWhodd(false)
    
    
    if(typeId === WHODD_CONCOMITANT_MEDICATION){
      masterObjectArray.map(i => {
        if (i.index == index) {
          i.whodd_id = checkboxId.whodd_id;
          i.medication_id = medicationId;

        }
      })
    setMasterObjectArray(masterObjectArray)
    



      let newObj = {
        medication_id:  medicationId,
        whodd: checkboxId
      }
      
      setCurrentSelectedIndex(index)
      // const newArray = [...masterObjectArray];
      // const newIndex = index-1
      // if (newIndex < newArray.length) {
      //   newArray[newIndex] = newObj;
      // } else {
      //   newArray.push(newObj);
      // }
      // setMasterObjectArray(newArray);
      
    }

    if(typeId === WHODD_ANY_MEDICATION_USED_IN_LAST_3WEEKS){
      masterArray.map(i => {
        if (i.index == index) {
          i.whodd_id = checkboxId.whodd_id;
          i.medication_id = medicationId
        }
      })
    setMasterArray(masterArray)

    



      let newObj = {
        medication_id:  medicationId,
        whodd: checkboxId
      }
      
      setCurrentSelectedIndex(index)
     
      
    }

    
    
    if (event.target.checked) {

      if (array?.length > 1) {
        setSelectedCheckboxes((prev) =>
          !prev.includes(checkboxId.whodd_id) ?
            [...prev, checkboxId.whodd_id] : prev
        )
      }
    } else {
      setSelectedCheckboxes((prevSelectedCheckboxes) =>
        prevSelectedCheckboxes.filter((id) => id !== checkboxId.whodd_id)
      );
    }
  };
  
  const handleCheckboxChange2 = (selectedCheckbox, index) => {

      setEncodeMeddrabtn(false)
      
    let updatedData = [...meddraDetails]
    updatedData.map(i => {
      if(i.current_idx === index){
        i.checkedMeddra = selectedCheckbox.meddra_mdhier_master_id
      }
    })
    meddraCodeArray.map(i => {
      if(i.index === index){
        i.meddra_llt_master_id = selectedCheckbox.meddra_llt_master_id
        i.meddra_mdhier_master_id = selectedCheckbox.meddra_mdhier_master_id
      }
    })
    setMeddraDetails(updatedData)
  };





  const handleAddMeddraFields = () => {
    setEncodeMeddrabtn(true)
    setMeddraDetails([...meddraDetails,
    {
      "searchTerm": "",
      "medDRAEncode": false,
      "meddra_type": typeId,
      "current_idx": currentIndex + 1,
      "checkedMeddra":"",
      "meddraAllergies": [],
      "meddraMhArray": [],
      "meddraIllArray": [],
    },]);
    setValue("")
    setCurrentIndex(currentIndex + 1);
    setEncodeMedBtn(false)
    
  };

  const handleAddWhoDDFields = () => {
    setMedicationDetails([...medicationDetails,
    {
      "searchTerm": "",
      "whoDD_type": typeId,
      "medication_id":medicationId,
      "current_idx": currentIndexWhoDD + 1,
      "checkedWhoDD":"",
      "whoDDEncode": false,
      "whoddArray": [],
      "concmtntWhoDDArray": [],
    },]);
    setValue1("")
    setCurrentIndexWhoDD(currentIndexWhoDD + 1);
    setEncodeBtn(false)
  };

  const [medraModal, setMedraModal] = useState(false)
  const [whoDDModal, setWhoDDModal] = useState(false)
  const [typeId, setTypeId] = useState()
useEffect(() =>{

},[typeId])
  const handleMeddraModal = (e) => {  
    if (e.target.id === 'allergies') {
      setTypeId(MEDDRA_ALLERGIES)
      if(meddraDetails[meddraDetails.length-1]?.meddra_type ===null)
        {meddraDetails[meddraDetails.length-1].meddra_type = MEDDRA_ALLERGIES}
        setEncodeMedBtn(false)
      if(meddraDetails.filter(i=>i.meddraAllergies!==0)){
        setEncodeMeddrabtn(false)
      }  else{
        
        setEncodeMeddrabtn(false)
      }
      
      }
      if (e.target.id === 'medicalhistory') {
        setTypeId(MEDDRA_MEDICAL_HISTORY)
        if(meddraDetails[meddraDetails.length-1].meddra_type ===null)
        {meddraDetails[meddraDetails.length-1].meddra_type = MEDDRA_MEDICAL_HISTORY}
        setEncodeMedBtn(false)
        if(meddraDetails.filter(i=>i.meddraMhArray!==0)){
          setEncodeMeddrabtn(false)
        }  else{
          
          setEncodeMeddrabtn(false)
        }
      }
      if (e.target.id === 'illness') {
        setTypeId(MEDDRA_CONCURRENT_ILLNESS)
        if(meddraDetails[meddraDetails.length-1].meddra_type ===null)
        {meddraDetails[meddraDetails.length-1].meddra_type = MEDDRA_CONCURRENT_ILLNESS}
        setEncodeMedBtn(false)
        if(meddraDetails.filter(i=>i.meddraIllArray!==0)){
          setEncodeMeddrabtn(false)
        }  else{
          
          setEncodeMeddrabtn(false)
        }
    }
    setMedraModal(true)
  }

  
  const openwhoDDModal = (e, i, index) => {
    setMedicationId(e.target.getAttribute('value'))
    if (e.target.id === "concomitantWhodd" ) {
      setTypeId(WHODD_CONCOMITANT_MEDICATION)
      if (medicationDetails[medicationDetails.length-1].whoDD_type === ''||medicationDetails[medicationDetails.length-1].whoDD_type === undefined ) {
        medicationDetails[medicationDetails.length-1].whoDD_type = WHODD_CONCOMITANT_MEDICATION
        medicationDetails[medicationDetails.length-1].medication_id = e.target.getAttribute('value')
      }
      setEncodeBtn(false) 
    }
    if (e.target.id === "medusedlast3mnths") {
      setTypeId(WHODD_ANY_MEDICATION_USED_IN_LAST_3WEEKS)
      if (medicationDetails[medicationDetails.length-1].whoDD_type === ''||medicationDetails[medicationDetails.length-1].whoDD_type === undefined) {
        medicationDetails[medicationDetails.length-1].whoDD_type = WHODD_ANY_MEDICATION_USED_IN_LAST_3WEEKS
        medicationDetails[medicationDetails.length-1].medication_id = e.target.getAttribute('value')
      }
      setEncodeBtn(false)
    }
    setWhoDDModal(true)
  }


  const onCloseMeddraModal = () => {
    setListFlag(false)
    setValue("")


    let data = meddraCodeArray.filter(i => i.meddra_type == typeId && i.meddra_mdhier_master_id == null)
    data.map(i => {
      let updatedData = [...meddraDetails]
      updatedData?.map((elemObj, j) => {
        if (elemObj.current_idx == i.index) {
          if (elemObj.meddra_type === MEDDRA_ALLERGIES) {
            elemObj.meddraAllergies = [];
            elemObj.searchTerm = ''
          }
          if (elemObj.meddra_type === MEDDRA_MEDICAL_HISTORY) {
            elemObj.meddraMhArray = [];
            elemObj.searchTerm = ''
          }
          if (elemObj.meddra_type === MEDDRA_CONCURRENT_ILLNESS) {
            elemObj.meddraIllArray = [];
            elemObj.searchTerm = ''
          }
        }
      })
      setMeddraDetails(updatedData)
    })
    setMedraModal(false)
  }

const handleClearAndCloseWhoddModal =()=>{

  if (typeId === WHODD_CONCOMITANT_MEDICATION) {
    qrSubjectInfoList?.concomitantMedication?.map((i, index) => {
      if (medicationId === i.concomitant_medication_id) {
        i.right_mark = false;
      }
    });
    let updatedmasterObjectArray = [...masterObjectArray];

    updatedmasterObjectArray?.some((ele, i) => {
      if (ele.medication_id == medicationId) {
        updatedmasterObjectArray.splice(i, 1)
      }
    })
    setMasterObjectArray(updatedmasterObjectArray);

  }
  else if (typeId === WHODD_ANY_MEDICATION_USED_IN_LAST_3WEEKS) {
    qrSubjectInfoList?.medUsedInLast3Weeks?.map((i, index) => {
      if (medicationId === i.subject_medication_used_in_last_3weeks_id) {
        i.right_mark = false;
      }
    });
    let updatedMasterArray = [...masterArray];

    updatedMasterArray?.some((ele, i) => {
      if (ele.medication_id == medicationId) {
        updatedMasterArray.splice(i, 1)
      }
    })
    setMasterArray(updatedMasterArray);
    
  }

  const updatedMedicationDetails = medicationDetails.map((item) => {
    if (item.whoDD_type === typeId && item?.medication_id === medicationId || (item?.medication_id === subjectID)) {
      item.searchTerm = "";
      item.current_idx = 0;
      item.whoDD_type = null;
      item.whoDDEncode = false;
      item.whoddArray = [];
      item.concmtntWhoDDArray = []
    }
    return item;
  });
  setMedicationDetails(updatedMedicationDetails);

 
setModalWhoddCloseAlert(false)
setTimeout(() => {
  setWhoDDModal(false)
}, 100);
}


  const onCloseWhoDDModal = () => {

    setNoRecordsFlag1(false)
    setListFlag1(false)
    if ((!revSubjDtls) && (medicationDetails.filter(i => i.medication_id == medicationId && i.whoDDEncode).length > 0) && ((masterObjectArray.some(i => i.whodd_id === null)) || (masterArray.some(i => i.whodd_id === null)))) {
      setAlrtMessage("Do you want to clear and exit?")
      setModalWhoddCloseAlert(true)
    }
    else {
      if (typeId === WHODD_CONCOMITANT_MEDICATION) {
        if(masterObjectArray.find(i => i.whodd_id !== null)){
          setSaveBtnWhodd(true)
        }
        let data = masterObjectArray.filter(i => i.whodd_id !== null)
        setMasterObjectArray(data)
        qrSubjectInfoList?.concomitantMedication?.map((i, index) => {
          if (masterObjectArray.find(x => x?.medication_id === i.concomitant_medication_id)) {
            i.right_mark = true;
          } else {
            i.right_mark = false
          }
        });
      } else if (typeId === WHODD_ANY_MEDICATION_USED_IN_LAST_3WEEKS) {
        let datatwo = masterArray.filter(i => i.whodd_id !== null)
        setMasterArray(datatwo)

        qrSubjectInfoList?.medUsedInLast3Weeks?.map((i, index) => {
          if (masterArray.find(x => x?.medication_id === i.subject_medication_used_in_last_3weeks_id)) {
            i.right_mark = true;
          } else {
            i.right_mark = false
          }
        });

      }
      setWhoDDModal(false)
    }


    //===============================


  }

  const handleAscending = () => {
    setAsC(true);
    setDesc(false);
    const sortedData = [...filteredData];
    sortedData.sort((a, b) => {
      const subjectCodeA = a.subject_code;
      const subjectCodeB = b.subject_code;
      return subjectCodeA.localeCompare(subjectCodeB);
    });
    setFilteredData(sortedData);
  };
  const handleDescending = () => {
    setDesc(true);
    setAsC(false);
    const sortedData = [...filteredData];
    sortedData.sort((a, b) => {
      const subjectCodeA = a.subject_code;
      const subjectCodeB = b.subject_code;
      return subjectCodeB.localeCompare(subjectCodeA);
    });
    setFilteredData(sortedData);
  };
  const [firstMed, setFirstMed] = useState([])
  const [firstWhoDD, setFirstWhoDD] = useState([])

  const handleSaveMeddra = () => {
    let truthyMedData = meddraDetails && meddraDetails?.filter(i => i.medDRAEncode === true)

    setMedraModal(false)


    let filteredMedTypeIds = truthyMedData.filter(i => firstMed.includes(i.meddra_type)).map(i => i.meddra_type)
    setFirstMed(filteredMedTypeIds)
    if (truthyMedData?.length === 0) {

      setFirstMed(firstMed.filter(i => i !== typeId))

      meddraDetails.map((data) => {
        data.searchTerm = ''
        data.medDRAEncode = false
        data.meddraAllergies = []
        data.meddraMhArray = []
      })
      setMeddraDetails(meddraDetails)
    }
    else (
      setMeddraDetails(truthyMedData)
    )


  }

 
  const handleDeleteMedDRA = () => {
    let data = meddraCodeArray.filter(i => i.meddra_type !== typeId)
    setMeddraCodeArray(data)
    const updatedMeddraDetails = meddraDetails.map((item) => {
      if (item.meddra_type === typeId) {
        item.searchTerm = "";
        item.current_idx = 0;
        item.meddra_type = null;
        item.checkedMeddra = "";
        item.medDRAEncode = false;
        item.meddraAllergies = [];
        item.meddraMhArray = [];
        item.meddraIllArray = [];
      }
      return item;
    });
    setMeddraDetails(updatedMeddraDetails);
  };
  const handleDeleteWhoDD = () => {
    
    let data = whoDDCodeArray.filter(i => i?.medication_id !== medicationId)
    setWhoDDCodeArray(data)
    setSaveBtnWhodd(true)

    if (typeId === WHODD_CONCOMITANT_MEDICATION) {
      qrSubjectInfoList?.concomitantMedication?.map((i, index) => {
        if (medicationId === i.concomitant_medication_id) {
          i.right_mark = false;
        }
      });
      let updatedmasterObjectArray = [...masterObjectArray];

      updatedmasterObjectArray?.some((ele, i) => {
        if (ele.medication_id == medicationId) {
          updatedmasterObjectArray.splice(i, 1)
        }
      })
      setMasterObjectArray(updatedmasterObjectArray);

    }
    else if (typeId === WHODD_ANY_MEDICATION_USED_IN_LAST_3WEEKS) {
      qrSubjectInfoList?.medUsedInLast3Weeks?.map((i, index) => {
        if (medicationId === i.subject_medication_used_in_last_3weeks_id) {
          i.right_mark = false;
        }
      });
      let updatedMasterArray = [...masterArray];

      updatedMasterArray?.some((ele, i) => {
        if (ele.medication_id == medicationId) {
          updatedMasterArray.splice(i, 1)
        }
      })
      setMasterArray(updatedMasterArray);
      
    }




    const updatedMedicationDetails = medicationDetails.map((item) => {
      if (item.whoDD_type === typeId && item?.medication_id === medicationId || (item?.medication_id === subjectID)) {
        item.searchTerm = "";
        item.current_idx = 0;
        item.whoDD_type = null;
        item.whoDDEncode = false;
        item.whoddArray = [];
        item.concmtntWhoDDArray = []
      }
      return item;
    });
    setMedicationDetails(updatedMedicationDetails);

    // ================================
    // if (typeId === WHODD_CONCOMITANT_MEDICATION) {
    //   whoddRightMark.concom_right_Mark = false
    //   const Val = masterObjectArray.findIndex(obj => obj?.medication_id === medicationId);
    //   if (Val !== -1) {
    //     setMasterObjectArray(prevList =>
    //       prevList.filter((obj, index) => index !== Val)
    //     );
    //   }

    // }

    // if (typeId === WHODD_ANY_MEDICATION_USED_IN_LAST_3WEEKS) {
    //   const Val = pastMasterObjectArray.findIndex(obj => obj?.medication_id === medicationId);
    //   if (Val !== -1) {
    //     setPastMasterObjectArray(prevList =>
    //       prevList.filter((obj, index) => index !== Val)
    //     );
    //   }

    // }

    setNoRecordsFlag1(false)
    setListFlag1(false)
  };


 
 
const handleSaveWhoDD =()=>{

qrSubjectInfoList?.concomitantMedication?.map((i, index) => {
      if (masterObjectArray.find(x => x?.medication_id === i.concomitant_medication_id)) {
        i.right_mark = true;
      }else{
        i.right_mark=false
      }
    });
qrSubjectInfoList?.medUsedInLast3Weeks?.map((i, index) => {
      if (masterArray.find(x => x?.medication_id === i.subject_medication_used_in_last_3weeks_id)) {
        i.right_mark = true;
      }else{
        i.right_mark=false
      }
    });
 

  let truthyWhoddData = medicationDetails?.filter(i => i.whoDDEncode ===true)

  let filteredWhoddTypeIds = truthyWhoddData.filter(i => firstWhoDD.includes(i.whoDD_type)).map(i => i.whoDD_type)
  setFirstWhoDD(filteredWhoddTypeIds)
    if(truthyWhoddData?.length ===0 ){

    setFirstWhoDD(firstWhoDD.filter(i => i!==typeId))

    medicationDetails.map((data) => {
    data.searchTerm = ''
    data.whoDDEncode=false
    data.whoddArray = []
    data.concmtntWhoDDArray=[]
    })
    setMedicationDetails(medicationDetails)
    }
    else(
    setMedicationDetails(truthyWhoddData)
    )

    if(typeId === WHODD_CONCOMITANT_MEDICATION){
       
      // const Val = masterObjectArray.findIndex(obj => obj?.medication_id === medicationId);
      // setMasterObjectArray(prevList =>
      //   Val !== -1 ? [...prevList.slice(0, Val), currentSelectedWhodd, ...prevList.slice(Val + 1)] : [...prevList, currentSelectedWhodd]
      // );
     
      // setCurrentSelectedIndex(index)
      // const newArray = [...masterObjectArray];
      // const newIndex = currentSelectedIndex-1
      // if (newIndex < newArray.length) {
      //   newArray[newIndex] = currentSelectedWhodd;
      // } else {
      //   newArray.push(currentSelectedWhodd);
      // }
      // setMasterObjectArray(newArray);
      
    }

    if(typeId === WHODD_ANY_MEDICATION_USED_IN_LAST_3WEEKS){
       
      // setCurrentSelectedWhodd(newObj)
      // setCurrentSelectedIndex(index)
      // const Val = pastMasterObjectArray.findIndex(obj => obj?.medication_id === medicationId);
      // setPastMasterObjectArray(prevList =>
      //   Val !== -1 ? [...prevList.slice(0, Val), currentSelectedWhodd, ...prevList.slice(Val + 1)] : [...prevList, currentSelectedWhodd]
      // );


      // const newArray = [...pastMasterObjectArray];
      // const newIndex = currentSelectedIndex-1
      // if (newIndex < newArray.length) {
      //   newArray[newIndex] = currentSelectedWhodd;
      // } else {
      //   newArray.push(currentSelectedWhodd);
      // }
      // setPastMasterObjectArray(newArray);
      
    }
  setWhoDDModal(false)
  setCurrentSelectedIndex("")
  setNoRecordsFlag1(false)
  setListFlag1(false)
}


let addMoreBtnStyl = 'white_btn px-2 py-1'
let footerSaveBtn = 'white_btn py-1 px-3'

const handleModalSave =()=>{
  setTimeout(() =>{
    setMedraModal(false)
    setWhoDDModal(false)
  },100)
  handleSaveMeddra()
  setModalAlert(false)
 
 window.location.reload();
}
const [enteredPassword, setEnteredPassword] = useState("")
const handleClose = () => {
  setPwdError(false)
  setEnteredPassword('')
  setPwdModalShow(false)
  if (pwdModalShow == false) {
      setEnteredPassword('')
  }
};
const [pwdError, setPwdError] = useState(false)

const handlePwdChange = (e) => {
  setEnteredPassword(e.target.value);
 
  
    };
    
  const handleConfirmPwd = () => {
    const bytes = CryptoJS.AES.decrypt(localStorage.getItem("pwdid"), CRYPTO_SECRET_KEY);
    const originalText = bytes.toString(CryptoJS.enc.Utf8);
    if (originalText === enteredPassword) {
      setPwdError(false)

      if (btnId === "closereview") {
        handlecloseReview()
      } else if (btnId === "sendBack") {
        sentBack()
      }
    } else {
      setPwdError(true)
    }

  }
 
let medi = qrSubjectInfoList?.medUsedInLast3Weeks?.[0];
let medicationUsedinlast3weeksflag = medi?.dosage == "" &&  medi?.frequency == "" && medi?.medication_name == "" && medi?.medication_route == ""
  return (
    <>
      <div>
      <PasswordModal pwdError={pwdError} handleConfirmPwd={handleConfirmPwd} handlePwdChange={handlePwdChange} enteredPassword={enteredPassword} pwdModalShow={pwdModalShow} handleClose={handleClose}/>
        <NavigationBar
          studyDropdwn={studyDropdwn}
          title={"Subjects Review"}
           
          handleFilteredData={handleStudyChange}
        />
        {/* <QRFlowLeftNavBar /> */}
        <div className="main_body">
        <PopUpModal
        handleClose={handleClosePopup}
        open={open1}
        title={"Success!"}
        msg={"Event has already been attended to!"}
        close={"Close"}
        actionbtn={"Done"}
        onConfirm={alreadyAttended}
      />
          {currentPage === 1 && (
            <Container fluid className="py-4 ">
              <Stack className="add_subject_stack ps-0">
                <div className="bg-white">
                  <Row className="row d-flex w-50 ">
                    {dashboardCards?.map((card, index) => {
                      return (
                        <Col key={index}>
                          <div
                            className="card-container C-pointer"
                            onClick={() => handleRadioChange(card.id)}
                            style={{ backgroundColor: card.bgcolor , outline: selectedOption === card.id ? "2px solid black" :"" }}
                          >
                            <div
                              className="content"
                              style={{ color: card.textColor }}
                            >
                              <span>{card.count}</span>
                              <img src={card.image} alt="" />
                            </div>
                            <div
                              className="desc"
                              style={{ color: card.textColor }}
                            >
                              {card.desc}
                            </div>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                </div>
              </Stack>

              {qrSubjectList && qrSubjectList?.length > 0 ? (
                <Container fluid className="pitable_container mt-2  ">
                  <Row className='searchbar'>
                    <Col className='searchFiled gap-3'>
                      <label htmlFor="" />
                      <input type="text" value={searchText} style={{ width: "400px" }} placeholder='Search with Subject ID or Site Name' onChange={handleSearchData} />
                      <div className=" ">
                        <button
                          className="btn btn-success"
                          onClick={exportToExcel}
                          style={{height:"42px"}}
                        >
                          Download XLS
                          <img src="./images/icons/download.svg" alt="#" style={{marginLeft:"5px"}}/>
                        </button>
                      </div>

                    </Col>
                  </Row>

                  <div>
                    {loading_flag ? (
                      <div className=''>
                        <img
                          className="atrium_loader"
                          src="/images/circle-effect-loading.gif"
                          alt="Loader"

                        />
                      </div>

                    ) : (
                      <div className="table-scroll-container " style={{ border: "1px solid #E1E5E7 " }}>
                        {filteredData?.length > 0 ?
                          <Table bordered size="sm"  className="pitable mb-0">
                            <thead className="sticky_table_header">
                              <tr>
                                <th> S.No</th>
                                <th className="sticky-header">
                                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                  <span style={{ fontSize: 14, fontWeight: 600, marginTop: 0,paddingLeft:"40%" }}>Subject ID</span>
                    <svg width="30" height="30" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" style={{float:"right"}}>
                      <g id="icon_sort">
                        <path id="icon" d="M13.3471 21.1433C13.1481 21.4277 12.7269 21.4277 12.5279 21.1433L8.23821 15.0152C8.00624 14.6839 8.24332 14.2285 8.64783 14.2285H17.2272C17.6317 14.2285 17.8688 14.6839 17.6368 15.0152L13.3471 21.1433Z" fill={desc?"black":"#E1E5E7"} onClick={handleDescending} className='svg-cursor'/>
                        <path id="icon_2" d="M13.3471 4.31368C13.1481 4.02932 12.7269 4.02932 12.5279 4.31368L8.23821 10.4418C8.00624 10.7732 8.24332 11.2285 8.64783 11.2285H17.2272C17.6317 11.2285 17.8688 10.7732 17.6368 10.4418L13.3471 4.31368Z" fill={asc?"black":"#E1E5E7"} onClick={handleAscending} className='svg-cursor'/>
                      </g>
                    </svg>
                    </div>
                </th>
                                <th style={{ minWidth: "145px" }}>
                                  Sex
                                </th>
                                <th>
                                  Site
                                </th>
                                <th>
                                  Events
                                </th>
                                <th>
                                  Principal Investigator
                                </th>
                             <th>Status</th>
                              </tr>
                            </thead>

                            <tbody className="tableBodyScroll ">
                              {filteredData?.map((i, index) => {
                                return (
                                  <tr key={i.index} className="text_left_table">
                                    <td className="text_right_sno"> {index + 1} </td>
                                    <td>{i.subject_code ? i.subject_code :"-"}</td>
                                    <td>{i.sex ? i.sex :"-"}</td>
                                    {/* <td>{i.site_name}</td> */}
                                    <td><span title={i.site_name}>{i.site_name ? i.site_name :"-"}</span></td>

                                    <td>{i.events_reported ? i.events_reported  + i.sae_count:"-"}</td>
                                    <td>{i.pi_name ? i.pi_name :"-"}</td>

                                    <td className="viewbtnstyles">
                                      {i.review_status ===
                                        SUBJECT_REVIEW_STATUS_WAITING_FOR_REVIEW && (
                                          <button
                                            className="gray_btn py-1 "
                                            onClick={() => handleSubjectData(i)}
                                          >
                                            Waiting for review
                                          </button>
                                        )}
                                      {i.review_status === SUBJECT_REVIEW_STATUS_IN_PROGRESS && (
                                        <button
                                          className="orange_btn py-1"
                                          onClick={() => handleSubjectData(i)}
                                        >
                                          In progress
                                        </button>
                                      )}
                                      {i.review_status === SUBJECT_REVIEW_STATUS_REVIEWED && (
                                        <button
                                          className="green_btn py-1"
                                          onClick={() => handleSubjectData(i)}
                                        >
                                          Reviewed
                                        </button>
                                      )}
                                      {i.review_status ===
                                        SUBJECT_REVIEW_STATUS_SENT_BACK_FOR_REVIEW && (
                                          <button
                                            className="red_btn py-1"
                                            disabled
                                          >
                                            Sent Back For Review
                                          </button>
                                        )}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                          :
                          <div className="bg-white border py-4 text-center">No records found with search criteria</div>

                        }
                      </div>
                    )}
                  </div>

                </Container>
              ) : qrSubjectList === null && localStorage.study_id ? <div className=''>
                  <img
                      className="atrium_loader"
                      src="/images/circle-effect-loading.gif"
                    alt="Loader"

                  />
                </div> :   (
                <>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: '5rem' }}>
                    <img src="./images/no_subjects.svg" alt="Telephone" />
                    <h5> No events found</h5>
                  </div>
                </>
              )}
            </Container>
          )}

          {currentPage === 2 && (
            <Container fluid className="p-0 page_two_styl">
              <div className="">
                <div className="mb-5 pb-5 pt-3 px-3 gap-3 d-grid">
                  <SubjectReviewDetails/>

                  <div className='row d-flex justify-content-center justify-content-md-between gap-3 mt-2 w-100'>
                    <div className="card col-md col-sm-12 w-100 p-0" >
                      <div className="card-header cardHeading">
                        <h6>Concomitant Medication</h6>
                      </div>
                      <div className="cardBody w-100">
                        {qrSubjectInfoList?.concomitantMedication?.concomitant_medication_id !== null ?
                          <div className=" body Concon_medication_main w-100">
                            <table className="table Concon_medication w-100">
                              <thead className='text-center'>
                                <tr>
                                  <th scope="col">Medication</th>
                                  <th scope="col">Batch Number</th>
                                  <th scope="col">Manufacturer</th>
                                  <th scope="col">Route/Site</th>
                                  <th scope="col">Dosage</th>
                                  <th scope="col">Frequency</th>
                                  <th scope="col">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {revSubjDtls? (revSubjDtls?.concomitantMedication?.map((i, index) => {
                                  return (
                                    <tr key={index} className='text-center'>
                                      <td>{i.medication ? i.medication :"-"}</td>
                                      <td>{i.medication_batch_number ? i.medication_batch_number :"-"}</td>
                                      <td>{i.medication_manufacturer ? i.medication_manufacturer :"-"}</td>
                                      <td>{i.medication_route_site ? i.medication_route_site :"-"}</td>
                                      <td>{i.medication_dosage ? i.medication_dosage :"-"}</td>
                                       <td>{i.medication_frequency ? i.medication_frequency :"-"}</td>  
                                      <td  className="medication_3_weeks"><button className="white_btn py-1 px-2" id="concomitantWhodd" value={i.concomitant_medication_id} onClick={(e) => openwhoDDModal(e, i, index)}
                                      style={{borderColor:revSubjDtls?.concomitantWhoddObjects?.length>0?"green":''}}
                                      disabled={!(revSubjDtls?.whoddDrugs?.some(j => j.medication_type==WHODD_CONCOMITANT_MEDICATION && j?.medication_id === i.concomitant_medication_id))&& revSubjDtls?.review_status==SUBJECT_REVIEW_STATUS_REVIEWED}
                                      >
                                      WhoDD
                                      {revSubjDtls&& revSubjDtls.whoddDrugs?.find((data) => data?.medication_id === i.concomitant_medication_id)?<i className="fa-solid fa-check text-success"/>:''}
                                      </button></td>
                                    </tr>
                                  );
                                })) : 
                                qrSubjectInfoList?.concomitantMedication?.map((i, index) => {
                                  return (
                                    <tr key={index} className='text-center'>
                                      <td>{i.medication ? i?.medication :""}</td>
                                      <td>{i.medication_batch_number ? i.medication_batch_number :""}</td>
                                      <td>{i.medication_manufacturer ? i.medication_manufacturer :""}</td>
                                      <td>{i.medication_route_site ? i.medication_route_site :""}</td>
                                      <td>{i.medication_dosage ? i.medication_dosage :""}</td>
                                       <td>{i.medication_frequency ? i.medication_frequency :""}</td>  
                                      <td  className="medication_3_weeks" >
                                        <button className="white_btn py-1 px-2" id="concomitantWhodd" value={i?.concomitant_medication_id} onClick={(e)=>openwhoDDModal(e, i, index)}>
                                      WHODD
                                      {i.right_mark ? <i className="fa-solid fa-check text-success"/>:""}
                                      </button>
                                      </td>
                                    </tr>
                                  );
                                })}            
                              </tbody>
                            </table>
                          </div>
                          :
                          <div className="concomitantMsg">
                            <p>No Concomitant Medication</p>
                          </div>}
                          
                      </div>
                      {qrSubjectInfoList?.concomitantMedication===null?
                          (
                            <div style={{display:"flex",justifyContent:"center"}}>
                            <p>No Concomitant Medication</p>
                          </div>
                          ):""}
                    </div>
                    

                    <div className="d-flex justify-content-center justify-content-md-between gap-3 mt-2 w-100 p-0">
                    <PastHealthHistory  qrSubjectInfoList={qrSubjectInfoList} 
                    revSubjDtls={revSubjDtls} handleMeddraModal={handleMeddraModal}
                      meddraCodeArray={meddraCodeArray} subjectID={subjectID} 
                      openwhoDDModal={openwhoDDModal} whoDDCodeArray={whoDDCodeArray}/>
                    <div className="card col-md col-sm-12 w-100 p-0" >
                      <div className="card-header cardHeading">
                        <h6> Any medication used in last 3 weeks</h6>
                      </div>
                      <div className="cardBody w-100">
                        {qrSubjectInfoList?.medicationUsedInLast3Weeks?.subject_medication_used_in_last_3weeks_id !== null ?
                          <div className=" body Concon_medication_main w-100">
                            <table className="table Concon_medication w-100">
                              <thead className='text-center'>
                                <tr>
                                  <th scope="col">Medication</th>
                                  <th scope="col">Route</th>
                                  <th scope="col">Dosage</th>
                                 <th scope="col">Frequency</th>
                                 <th scope="col">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {revSubjDtls? (revSubjDtls?.medicationUsedInLast3Weeks?.map((i, index) => {
                                  return (
                                    <tr key={index} className='text-center'>
                                      <td>{i.medication_name ? i.medication_name :"-" }</td>
                                      <td>{i.medication_route ? i.medication_route :"-"}</td>
                                       <td>{i.dosage ? i.dosage :"-"}</td>
                                       <td>{i.frequency ? i.frequency :"-"}</td>  
                                      <td  className="medication_3_weeks"><button className="white_btn py-1 px-2" id="medusedlast3mnths" value={i.subject_medication_used_in_last_3weeks_id} onClick={openwhoDDModal}
                                      style={{borderColor:revSubjDtls?.whoddObjects?.length>0?"green":''}}
                                      disabled={!(revSubjDtls?.whoddDrugs?.some(j => j.medication_type==WHODD_ANY_MEDICATION_USED_IN_LAST_3WEEKS && j?.medication_id === i.subject_medication_used_in_last_3weeks_id))&& revSubjDtls?.review_status==SUBJECT_REVIEW_STATUS_REVIEWED}
                                      >
                                      WhoDD
                                      {revSubjDtls&& revSubjDtls.whoddDrugs?.find((data) => data?.medication_id === i.subject_medication_used_in_last_3weeks_id)?<i className="fa-solid fa-check text-success"/>:''}
                                      </button></td>
                                    </tr>
                                  );
                                })) :(!medicationUsedinlast3weeksflag) ? 
                                 qrSubjectInfoList?.medUsedInLast3Weeks?.map((i, index) => {
                                  return (
                                    <tr key={index} className='text-center'>
                                      <td>{i.medication_name ? i.medication_name :"-"}</td>
                                      <td>{i.medication_route ? i.medication_route :"-"}</td>
                                       <td>{i.dosage ? i.dosage :"-"}</td>
                                       <td>{i.frequency ? i.frequency :"-"}</td> 
                                      <td className="medication_3_weeks"><button className="white_btn py-1 px-2" id="medusedlast3mnths" value={i.subject_medication_used_in_last_3weeks_id} onClick={(e) => openwhoDDModal(e, i, index)}>
                                      WHODD
                                      {i.right_mark ? <i className="fa-solid fa-check text-success"/>:""}
                                      </button></td>
                                    </tr>
                                  );
                                }) :  "" }         
                              </tbody>
                            </table>
                          </div>
                          :
                          <div className="concomitantMsg">
                            <p>No  Medication Used in last 3 weeks</p>
                          </div>
                          }
                         
                      </div>
                      {qrSubjectInfoList?.medUsedInLast3Weeks===null?(
                       <div style={{display:"flex",justifyContent:"center"}}>
                       <p >No Medication Used in last 3 weeks</p>
                     </div>
                    ):""}
                    {medicationUsedinlast3weeksflag && (
                       <div style={{display:"flex",justifyContent:"center"}}>
                       <p >No Medication Used in last 3 weeks</p>
                     </div>
                    ) 
                    }
                    </div>
                    
                   
                    </div>
                  </div>

                  <div className=''>
                  <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "20px",
                        width: "100%",
                        alignItems: "start",
                      }}
                    >
                      <label htmlFor="add your comments" className="fw-bold fs-6">
                        {reviewedDtls ? "Comments" : "Add your comments"}<span className="text-danger">{reviewedDtls?'': "*"}</span>
                      </label>
                      {!revSubjDtls?.comments &&   <textarea
                        id="add_your_comments"
                        style={{
                          width: "100%",
                          minHeight: "100px",
                          borderColor: "#E1E5E7",
                          borderRadius: "8px",
                          padding: "10px"
                        }}
                        disabled={reviewedDtls}
                        placeholder={`${revSubjDtls ? revSubjDtls?.comments ===undefined ? '-':revSubjDtls?.comments : "type here"}`}
                        onChange={handleReviewerComments}
                      />}
                    </div>
                    <div className="d-flex gap-3 flex-column ">
                      {
                        revSubjDtls?.comments?.map(i =>{
                          return(
                          <div className="p-3 border rounded bg-white">
                      
                          <p className="mb-1"><b>Comment :</b> {i.comment}</p>
                          <p className="mb-1"><b>At :</b> {i.createdAt}</p>
                          </div>
                      
                        )})
                      }
                    </div>
                  </div>
                </div>
                <div className="registrationStepsFooter" >
                  {subjData.review_status === SUBJECT_REVIEW_STATUS_REVIEWED ?
                    <button className="white_btn white_btn_back px-3" onClick={handleReviewBtns}>
                      Back
                    </button>
                    : <div className="d-flex gap-2">
                      <button className="white_btn white_btn_back px-3" id={'cancel'} onClick={handleReviewBtns}>
                        Back
                      </button>
                      <button
                        id={'sendBack'}
                        className="red_btn"
                        onClick={handleReviewBtns}
                        disabled={reviewerComment === ''}
                      >
                        Send Back for Correction
                      </button>

                      <button
                        id={'closereview'}
                        className="green_btn"
                        onClick={handleReviewBtns}
                        disabled={!(medraSelected)}

                      >
                        Close Review
                      </button>
                    </div>}
                </div>
              </div>
            </Container>
          )}
        </div>
        <PopUpAlert
          handleClose={handleClosePopup}
          open={open}
          // title={"?"}
          msg={alertMessage}
          close={"Cancel"}
          actionbtn={'Sure'}
          onConfirm={handleReviewActions}
        />
        <PopUpAlert
          handleClose={handleClosePopup}
          open={openTwo}
          // title={"?"}
          msg={alertMessage}
          close={"Cancel"}
          actionbtn={'Sure'}
          onConfirm={handleAlertTwo}
        />
        <PopUpAlert
          handleClose={handleClosePopup}
          open={openThree}
          // title={"?"}
          msg={alertMessage}
          close={"Cancel"}
          actionbtn={'Sure'}
          onConfirm={handleAlertThree}
        />
        <PopUpAlert
          handleClose={handleClosePopup}
          open={modalWhoddCloseAlert}
          // title={"?"}
          msg={alertMessage}
          close={"No"}
          actionbtn={'Sure'}
          onConfirm={handleClearAndCloseWhoddModal}
        />
        
        <PopUpModal
          handleClose={handleNoModalAlert}
          open={modalAlert}
          title={"Success!"}
          msg={alertMessage}
          close={""}
          actionbtn={'Done'}
          onConfirm={handleModalSave}
        />
      </div>
      {loading && <Loader />}
      <Modal
        size="lg"
        show={medraModal}
        onHide={
          onCloseMeddraModal

        }
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton className="py-2">
          <Modal.Title id="example-modal-sizes-title-lg ">
            MedDRA
          </Modal.Title>
        </Modal.Header>
        {revSubjDtls ? 
        <GetMeddraBody revSubjDtls={revSubjDtls} typeId={typeId}/>
        :
         <Modal.Body className="medra_modal_body" style={{ minHeight: "50vh", maxHeight:"70vh" }}>

          {meddraDetails?.map((input, index) => {
            if ((input?.meddra_type === typeId)) {
              return (
                <div className="card review_card_bg pt-3" key={input.current_idx}>
                  {(meddraDetails?.find(i => i.meddra_type === typeId).current_idx !== input.current_idx) && (
                    <button
                      onClick={() => handleDeleteFields(input.current_idx)}
                      className="cross_btn"
                    >
                      <span>x</span>
                    </button>
                  )}
                 
                 
                  <div className="row justify-content-center"  >
                    <div className="col-4 ">
                      <label htmlFor="lastName" className="custm_label_fw" style={{ marginLeft: "10px" }}>
                        MedDRA Classification
                      </label>
                    </div>
                    <div className="col">
                      <div
                        style={{ display: "flex", alignItems: "center" }}
                        className="buttonIn"
                      >
                        <input
                          type="text"
                          name="medracode"
                          className="form-control mb-2 "
                          id="text"
                          value={input.searchTerm}
                          onChange={(e) => handleMeddraClassification1(e, input.current_idx)}
                          placeholder="Enter LLT Name"
                          style={{ flex: "1", right: "2px", paddingRight: "80px" }}
                        />
                        <button onClick={() => onEncode2(value, input)} className="medra_button" id="clear" disabled={!encodeMedBtn}>
                          Search
                        </button>
                      </div>
                      <div className="dropdown drop_medra card mb-3 border-0">
                        <div className="" style={{ height: listFlag && input.medDRAEncode === false && "180px", overflow: "auto", position: "relative" }}>

                        <ThreeDots
                      height="40"
                      width="40"
                      radius="9"
                      color="lightgray"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{ left: "50%", position: "absolute", top: "0px" }}
                      wrapperClassName="position-absolute"
                      visible={dotsFlag}
                    />

                    {noRecordsFlag && <div className="d-flex justify-content-center m-auto align-items-center h-100">No records found</div>}

                          {input.medDRAEncode === false && (suggestions != null ? suggestions
                            .filter((item) => {
                              const isLltInMeddraDetails = !meddraDetails?.some(i =>
                                (typeId==MEDDRA_ALLERGIES?
                                i.meddraAllergies:typeId==MEDDRA_MEDICAL_HISTORY ?
                                i.meddraMhArray:typeId==MEDDRA_CONCURRENT_ILLNESS?
                                i.meddraIllArray:[])?.some(allergy => allergy.llt_name === item.llt_name)
                              );
                            
                              const searchTerm = value?.toLowerCase();
                              const fullName = item.llt_name?.toLowerCase();
                              return (
                                isLltInMeddraDetails &&
                                searchTerm &&
                                fullName.startsWith(searchTerm) &&
                                fullName !== searchTerm
                              );
                            })
                            .slice(0, 10)
                            .map((item) => (
                              <div
                                onClick={() => onSearch(item.llt_name, input.current_idx)}
                                className="dropdown-row ms-3 mb-1 me-2 rounded px-2 py-1"
                                key={item.llt_name}
                              >
                                {item.llt_name}
                              </div>
                            )) : "")}
                          <ThreeDots
                            height="40"
                            width="40"
                            radius="9"
                            color="lightgray"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{ left: "50%", position: "absolute", top: "0px" }}
                            wrapperClassName="position-absolute"
                            visible={!suggestions}
                          />

                        </div>
                      </div>

                    </div>
                      <MeddraArray
                        inputmeddraArray={input.meddraAllergies}
                        inputcurrent_idx={input.current_idx}
                        inputcheckedMeddra={input.checkedMeddra}
                        handleCheckboxChange2={handleCheckboxChange2} />
                      <MeddraArray
                        inputmeddraArray={input.meddraMhArray}
                        inputcurrent_idx={input.current_idx}
                        inputcheckedMeddra={input.checkedMeddra}
                        handleCheckboxChange2={handleCheckboxChange2} />
                      <MeddraArray
                        inputmeddraArray={input.meddraIllArray}
                        inputcurrent_idx={input.current_idx}
                        inputcheckedMeddra={input.checkedMeddra}
                        handleCheckboxChange2={handleCheckboxChange2} />
                  </div>

                </div>
              )
            }else if(meddraDetails?.filter(i => i.meddra_type === typeId).length === 0){
              handleAddMeddraFields()
            } 
          })}
          {!reviewedDtls &&  <div className="addBtn mt-1">
            <button
              className={addMoreBtnStyl}
              onClick={handleAddMeddraFields}
              disabled={encodeMeddrabtn ||meddraCodeArray.filter(i => i.meddra_type==typeId && i.meddra_llt_master_id).length==0}
            >
              Add More
            </button>
          </div>}

        </Modal.Body>}
        <ModalFooter className="pe-2 py-1" >
          <button className={`red_btn py-1`} onClick={handleDeleteMedDRA}
           disabled={meddraCodeArray.filter(i => i.meddra_type==typeId && i.meddra_llt_master_id).length==0} >Clear</button>
          <button className={footerSaveBtn} onClick={handleSaveMeddra}
           disabled={meddraCodeArray.filter(i => i.meddra_type==typeId && i.meddra_llt_master_id).length==0}>Save</button>
        </ModalFooter>
        
      </Modal>



      <Modal
        size="lg"
        show={whoDDModal}
        onHide={onCloseWhoDDModal}
        backdrop={"static"}
        aria-labelledby="example-modal-sizes-title-lg"
        keyboard={false}
        className="modal"
      >
        <Modal.Header  className="py-2 modal-header" >
          <Modal.Title id="example-modal-sizes-title-lg">
          WHODD
          </Modal.Title>
          <button type="button " className="close white_btn px-2 modalClosebtn" style={{color:""}} data-dismiss="modal" aria-label="Close" onClick={onCloseWhoDDModal}>
          <span className="fs-3" style={{height:"22px"}} aria-hidden="true">&times;</span>
        </button>
        </Modal.Header>
        {revSubjDtls ? 
        
        <GetWhoDDBody revSubjDtls={revSubjDtls} typeId={typeId} medicationId ={medicationId} reviewedDtls={reviewedDtls} />
        :

        <Modal.Body className="medra_modal_body" style={{ minHeight: "50vh", maxHeight:"70vh" }}>
          {medicationDetails?.map((input, index) => {
            const uniqueGenericNames = [...new Set(whoddList?.map(item => item.generic_name.toLowerCase()))];
            const concatNames = [...uniqueGenericNames, ...new Set(whoddList?.map(item => item.product_name.toLowerCase()))]
              if((input.whoDD_type === typeId )&&((input?.medication_id === medicationId)||(input?.medication_id === subjectID)))
              
              {
                return (
                  <div className="card review_card_bg pt-3" key={index}>
                   
                    
                  <WhoddSearchBlock
                  input={input}
                  reviewedDtls={reviewedDtls}
                  handleWhoddFunction={handleWhoDDClassification}
                  encodeBtn={encodeBtn}
                  onEncode1={onEncode1}
                  value1={value1}
                  listFlag1={listFlag1}
                  dotsFlag1={dotsFlag1}
                  noRecordsFlag1={noRecordsFlag1}
                  suggestionsWhodd={suggestionsWhodd}
                  loadFlag1={loadFlag1}
                  masterArray={masterArray}
                  masterObjectArray={masterObjectArray}
                  handleCheckboxChange={handleCheckboxChange}
                  onSearch1={onSearch1}
                  medicationId={medicationId}
                  typeId={typeId}
                />


                  </div>
                )
              }else if(medicationDetails?.filter(i => (i.whoDD_type === typeId )&&((i?.medication_id === medicationId)||(i.medication_id === subjectID))).length === 0){
                handleAddWhoDDFields()
              }
          })}
      
        </Modal.Body>
        
        }
        <ModalFooter className="pe-2 py-1" >
        {!revSubjDtls && <div className="d-flex gap-3 m-0">
          <button className={`red_btn py-1`} onClick={(e) => handleDeleteWhoDD()}
             >Clear</button>
          
          {medicationDetails?.map((input, index) => {
              if((input.whoDD_type === typeId )&&((input?.medication_id === medicationId)||(input?.medication_id === subjectID)))
              
              {
                return (
             <button key={index} className={footerSaveBtn} onClick={handleSaveWhoDD}
             disabled={!input.whoDDEncode || saveBtnWhodd}>Save</button>

                )}})}

             
        </div>}
        </ModalFooter>
      </Modal>
    </>
  );
};
export default QrSubjectReview;

export const GetMeddraBody = ({revSubjDtls,typeId }) => {
  return (
    <Modal.Body className="medra_modal_body" style={{ minHeight: "50vh" }}>
          {revSubjDtls?.meddraObjects?.map((input, index) => {
            if ((input?.meddra_type == typeId)) {
              return (

                <div className="card review_card_bg pt-3" key={index}>
                  
                  <div className="row "  >
                    <div className="col-4">
                      <label htmlFor="lastName" className="custm_label_fw" style={{ marginLeft: "10px" }}>
                        MedDRA Classification
                      </label>
                    </div>
                     <MeddraForm revSubjDtls={revSubjDtls} object={input}/>
                  </div>
                </div>
              )
            } 
           
          })}

        </Modal.Body>
  );
};

export const GetWhoDDBody = ({ revSubjDtls, typeId, reviewedDtls, medicationId }) => {
  useEffect(() => {

  }, [typeId])
  return (
    <Modal.Body className="medra_modal_body">
      {revSubjDtls?.whoddDrugs?.map((input, index) => {
        if (input?.medication_type == typeId && input?.medication_id == medicationId)
          return (
            <div className="card review_card_bg pt-3" key={index}>
              <div className="row">
                <div className="col-4">
                  <label htmlFor="lastName" className="custm_label_fw whodd_label_mr_event_review" style={{ marginLeft: "15px" }}>
                    WHODD Classification
                  </label>
                </div>
                <div className="">
                  <div className="card mb-4 review_inner_card_bg_white_whodd ">

                    <div className="card-body">
                      <WhoDDForm value={input} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )

      })}
      {revSubjDtls?.concomitantWhoddObjects?.map((input, index) => {
        if (input?.medication_type == typeId && input?.medication_id == medicationId)

          return (
            <div className="card review_card_bg pt-3" >

              <div className="row" key={input.id}>
                <div className="col-4">
                  <label htmlFor="lastName" className="custm_label_fw" style={{ marginLeft: "15px" }}>
                    WHODD Classification
                  </label>
                </div>
                <div className="col">
                  <div className="card mb-4 review_inner_card_bg ">
                    <div className="card-body">
                      <form>
                        <div className="form-group row">
                          <label className="col col-form-label review_inner_card_text">
                            Drug Name
                          </label>
                          <div className="col-12">
                            <input
                              type="text"
                              value={input?.generic_name}
                              name="Genric Name"
                              disabled
                              className="form-control"
                              id="text"
                              placeholder="Product"
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            htmlFor="llt_name"
                            className="col col-form-label review_inner_card_text"
                          >
                            ATC Code
                          </label>
                          <div className="col-12">
                            <input
                              type="text"
                              value={input?.atc_code}
                              name="ATC"
                              disabled
                              className="form-control"
                              id="text"
                              placeholder="ATC"
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col col-form-label review_inner_card_text">
                            Product Code
                          </label>
                          <div className="col-12">
                            <input
                              type="text"
                              value={input?.product_name}
                              name="Product"
                              disabled
                              className="form-control"
                              id="text"
                              placeholder="Product"
                            />
                          </div>
                        </div>

                        <div className="form-group row">
                          <label className="col col-form-label review_inner_card_text">
                            Indication
                          </label>
                          <div className="col-12">
                            <input
                              type="text"
                              value={input?.indication}
                              name="Product"
                              disabled
                              className="form-control"
                              id="text"
                              placeholder="Product"
                            />
                          </div>
                        </div>

                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )

      })}


    </Modal.Body>
  );
};


export const PastHealthHistory = ({qrSubjectInfoList,revSubjDtls,handleMeddraModal,meddraCodeArray,subjectID,openwhoDDModal,whoDDCodeArray }) => {

  return (
    <div className="card col-md col-sm-12 w-100 p-0" >
      <div className="card-header cardHeading">
      <h6>Past Health History</h6>
    </div>
    <div className="  table-responsive body">
      <table className="table card_columns_styl border-0">
        <tbody>
          {qrSubjectInfoList?.allergies !== null && qrSubjectInfoList?.allergies !== undefined && qrSubjectInfoList?.allergies !== ""  &&  <tr>
            <td>Allergies</td>
            <td>{qrSubjectInfoList?.allergies}</td>
            <td ><button id='allergies' className="white_btn py-1"
            disabled={!(revSubjDtls?.meddraObjects?.some(i => i.meddra_type == MEDDRA_ALLERGIES)) && revSubjDtls?.review_status==SUBJECT_REVIEW_STATUS_REVIEWED}
             onClick={(e) => handleMeddraModal(e)} 
            style={{borderColor:revSubjDtls?.meddraObjects?.length>0?"green":''}}
            >MedDRA 
            {meddraCodeArray.filter(i => i.meddra_type==1 && i.meddra_llt_master_id).length>0&&<i className="fa-solid fa-check text-success"/>}
            {revSubjDtls?.meddraObjects?.some(i => i.meddra_type == MEDDRA_ALLERGIES)                             
            
            ?<i className="fa-solid fa-check text-success"/>:''}</button></td>
          </tr>}
          {qrSubjectInfoList?.medical_history !== null && qrSubjectInfoList?.medical_history !== undefined && qrSubjectInfoList?.medical_history !== "" && <tr>
            <td>Medical History</td>
            <td>{qrSubjectInfoList?.medical_history}</td>
            <td ><button id='medicalhistory' className="white_btn py-1" onClick={(e) => handleMeddraModal(e)}
            style={{borderColor:revSubjDtls?.meddraObjects?.length>0?"green":''}}  disabled={!(revSubjDtls?.meddraObjects?.some(i => i.meddra_type == MEDDRA_MEDICAL_HISTORY)) && revSubjDtls?.review_status==SUBJECT_REVIEW_STATUS_REVIEWED}
            >MedDRA
            {meddraCodeArray.filter(i => i.meddra_type==2 && i.meddra_llt_master_id).length>0&& <i className="fa-solid fa-check text-success"/>}
            {revSubjDtls?.meddraObjects?.some(i => i.meddra_type == MEDDRA_MEDICAL_HISTORY)?<i className="fa-solid fa-check text-success"/>:''}</button></td>
          </tr>}
          {qrSubjectInfoList?.concurrent_illness !== null && qrSubjectInfoList?.concurrent_illness !== undefined && qrSubjectInfoList?.concurrent_illness !== "" && <tr>
            <td>Illness</td>
            <td>{qrSubjectInfoList?.concurrent_illness}</td>
            <td ><button id='illness' className="white_btn py-1" onClick={(e) => handleMeddraModal(e)}
            style={{borderColor:revSubjDtls?.meddraObjects?.length>0?"green":''}} disabled={!(revSubjDtls?.meddraObjects?.some(i => i.meddra_type == MEDDRA_CONCURRENT_ILLNESS)) && revSubjDtls?.review_status==SUBJECT_REVIEW_STATUS_REVIEWED}
            >MedDRA
            {meddraCodeArray.filter(i => i.meddra_type==3 && i.meddra_llt_master_id).length>0&&<i className="fa-solid fa-check text-success"/>}
            {revSubjDtls?.meddraObjects?.some(i => i.meddra_type == MEDDRA_CONCURRENT_ILLNESS)?<i className="fa-solid fa-check text-success"/>:''}</button></td>
          </tr>}
        
        </tbody>

      </table>
      
    </div>
    <div className="d-flex justify-content-center">
      {(qrSubjectInfoList?.allergies === null || qrSubjectInfoList?.allergies === undefined  || qrSubjectInfoList?.allergies === "")&& 
        (qrSubjectInfoList?.medical_history === null || qrSubjectInfoList?.medical_history === undefined || qrSubjectInfoList?.medical_history === "")  &&
        (qrSubjectInfoList?.concurrent_illness === null || qrSubjectInfoList?.concurrent_illness  === undefined ||qrSubjectInfoList?.concurrent_illness ==="" )&&
        <div style={{display:"flex",justifyContent:"center"}} >
          <p >No Past Health History</p>
        </div>
      }
    </div>
  </div>
  );
};

export const WhoDDConcomAndWhodd = ({masterObjectArray, typeId, inputArray,savedWhodd, input, handleCheckboxChange, masterArray, medicationId }) => {
  return (
    <div className="ps-5" style={{maxHeight:"445px", overflow:"auto"}}>
      {inputArray?.map((ele, index) => {
        const moreThanone = inputArray.length > 1
        return (
          <div key={index} className="position-relative out_orange_radiobtn">
            <input
              type="radio"
              className="custm_out_radiobtn"
              checked={(moreThanone && typeId === WHODD_CONCOMITANT_MEDICATION)  ? (masterObjectArray?.some(item => item?.whodd_id === ele?.whodd_id && item?.medication_id === medicationId)) : 
                (moreThanone && typeId === WHODD_ANY_MEDICATION_USED_IN_LAST_3WEEKS ) ? (masterArray?.some(item => item?.whodd_id === ele?.whodd_id && item?.medication_id === medicationId))
             : ele.whodd_id}
              id={ele.whodd_id}
              onChange={(e) => handleCheckboxChange(e, ele, input.current_idx)}
              style={{ width: "18px", marginRight:"-20px" }}
            />

            <div className="card mb-4 review_inner_card_bg_white_whodd">
              <div className="card-body">
              <WhoDDForm value ={ele}/>
              </div>
            </div>
          </div>
        )
      }
      )}
    </div>
  )
}

export const WhoDDFormField=({title, value, custmdivstyl})=>{
  return(
    <div className="row d-flex mb-2">
    <div className="col">
      <label className="">
        {title}
      </label>
      <div className=" ">
        <p>{value}</p>
       </div>
    </div>
  </div>
  )
}